import React, { Fragment, useEffect, useContext, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";
import moment from "moment";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

import Loading from "@component/UI/Loading";

export default () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { site, iam } = useContext(AppContext);
    const { idx } = useParams();
    const [cfg, setCfg] = useState(null);
    const [fix, setFix] = useState([]);
    const [add, setAdd] = useState([]);
    const [topic, setTopic] = useState([]);
    const [detail, setDetail] = useState(null);
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const loadData = () => {
        _API.get({ path: "/site/abstract/item", data: { idx } })
            .then((res) => {
                const data = res.data;
                if (!data?.signuture) {
                    data.signuture = iam?.nameFirst + " " + iam?.nameLast;
                }
                if (!data?.signutureDate) {
                    data.signutureDate = moment().format("YYYY-MM-DD");
                } else {
                    data.signutureDate = moment(data.signutureDate).format("YYYY-MM-DD");
                }

                setData(data);
                setIsLoading(false);
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => {
                    navigate("/");
                });
            });
    };

    const loadConfig = () => {
        _API.get({ path: "/site/abstract/config" })
            .then((res) => {
                const { cfg, fixOptions, addOptions, topicOptions, detailOption } = res.data;
                setCfg(cfg);
                setFix(fixOptions);
                setAdd(addOptions);
                setTopic(topicOptions);
                setDetail(detailOption);
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => {
                    navigate("/");
                });
            });
    };

    useEffect(() => {
        if (site?.siteCode) {
            loadConfig();
        }
    }, [site?.siteCode]);

    useEffect(() => {
        if (cfg && idx) {
            loadData();
        }
    }, [cfg, idx]);

    const findFixItem = (type) => {
        const item = fix.find((f) => f.type === type);
        if (item) {
            return item;
        }

        return false;
    };

    const getDetailOption = (type) => {
        switch (type) {
            case "WORD-LIMIT":
                if (data?.abstractType === detail?.caseReportTitle) {
                    return detail?.caseWordLimit;
                } else {
                    return detail?.abstractWordLimit;
                }
            case "BACKGROUND-TITLE":
                if (data?.abstractType === detail?.caseReportTitle) {
                    return detail?.caseBackgroundTitle;
                } else {
                    return detail?.abstractBackgroundTitle;
                }
            case "CONCLUSIONS-TITLE":
                if (data?.abstractType === detail?.caseReportTitle) {
                    return detail?.caseConclusionsTitle;
                } else {
                    return detail?.abstractConclusionsTitle;
                }
            case "METHOD-TITLE":
                if (data?.abstractType === detail?.caseReportTitle) {
                    return detail?.caseMethodTitle;
                } else {
                    return detail?.abstractMethodTitle;
                }
            case "RESULTS-TITLE":
                if (data?.abstractType === detail?.caseReportTitle) {
                    return detail?.caseResultsTitle;
                } else {
                    return detail?.abstractResultsTitle;
                }
            case "BACKGROUND-USE":
                if (data?.abstractType === detail?.caseReportTitle) {
                    return detail?.isUseCaseBackground;
                } else {
                    return detail?.isUseAbstractBackground;
                }
            case "CONCLUSIONS-USE":
                if (data?.abstractType === detail?.caseReportTitle) {
                    return detail?.isUseCaseConclusions;
                } else {
                    return detail?.isUseAbstractConclusions;
                }
            case "METHOD-USE":
                if (data?.abstractType === detail?.caseReportTitle) {
                    return detail?.isUseCaseMethod;
                } else {
                    return detail?.isUseAbstractMethod;
                }
            case "RESULTS-USE":
                if (data?.abstractType === detail?.caseReportTitle) {
                    return detail?.isUseCaseResult;
                } else {
                    return detail?.isUseAbstractResults;
                }
        }
    };

    const getAff = () => {
        if (!data?.authorAff || data?.authorAff?.length === 0) {
            return;
        }

        const result = [];
        for (let i in data?.authorAff) {
            const a = data?.authorAff[i];

            result.push(
                <div>
                    ({parseInt(i) + 1}) {a.department}, {a.inst}, {a.city}, {_DEF.getDefinedLabel(_DEF.COUNTRY, a.country)}
                </div>
            );
        }

        return result;
    };

    const getAuthor = () => {
        if (!data?.authorInformation || data?.authorInformation?.length === 0) {
            return;
        }

        const result = [];
        for (let i in data?.authorInformation) {
            const a = data?.authorInformation[i];

            result.push(
                <div>
                    {a.title}&nbsp;
                    {a.nameFirst} {a.nameLast} ({parseInt(a.aff || 0) + 1}) {a.email}
                    {a.present === "Y" && " (Presenting)"}
                    {a.corresponding === "Y" && " (Corresponding)"}
                </div>
            );
        }

        return result;
    };

    const onSave = () => {
        const mode = location?.pathname?.includes("/modify") ? "MODIFY" : "ADD";

        _API.post({ path: "/site/abstract/step2", data: { ...data, mode } })
            .then((res) => {
                if (res.error === 0) {
                    swal("Your submission has been completed. A confirmation email has been sent to you. You can modify or withdraw your abstract at My Page > Abstract Status.").then(() => {
                        navigate("/mypage/abstract");
                    });
                }
            })
            .catch((e) => {
                console.log(e);

                _API.alert({ message: e.message });
            });
    };

    if (!_CK.isLogin()) {
        swal("Please Login first.").then(() => {
            document.location.href = "/";
        });
        return;
    }

    return (
        <Fragment>
            {isLoading && <Loading />}
            <div className="contents">
                {site?.naviAbstract && parse(site?.naviAbstract)}

                <div className="right">
                    <div className="contentsTop">
                        <h3>On-line Submission</h3>
                        <div className="location">
                            <a href="/" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>On-line Submission</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        <p style={{ fontSize: "1rem", fontWeight: "bold" }} className="mb5">Please ensure that all information provided is accurate and
                            complete before final submission.
                        </p>
                        <table className="tbl_abs">
                            <tr>
                                <th width="20%">Abstract No</th>
                                <td>{data?.abstractNo}</td>
                            </tr>
                            {findFixItem("ABSTRACT_TYPE") && (
                                <tr>
                                    <th>{findFixItem("ABSTRACT_TYPE")?.title}</th>
                                    <td>{data?.abstractType}</td>
                                </tr>
                            )}
                            {add?.map((item, index) => (
                                <tr key={index}>
                                    <th>{item.title}</th>
                                    <td>
                                        {item.type === "CHECK" ? <>{data?.metadata[item.name]?.join(",")}</> : <>{data?.metadata[item.name]}</>}

                                        {data?.metadata[item.name + "Others"] && <>({data?.metadata[item.name + "Others"]})</>}
                                    </td>
                                </tr>
                            ))}
                            {findFixItem("TITLE") && (
                                <tr>
                                    <th>{findFixItem("TITLE")?.title}</th>
                                    <td>
                                        {findFixItem("TITLE")?.isUseEditor === "Y" ? (
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: data?.title,
                                                }}
                                            ></div>
                                        ) : (
                                            data?.title
                                        )}
                                    </td>
                                </tr>
                            )}
                            {findFixItem("ABSTRACT_DETAIL") && (
                                <tr>
                                    <th>{findFixItem("ABSTRACT_DETAIL")?.title}</th>
                                    <td>
                                        <table className="tbl_abs">
                                            {getDetailOption("BACKGROUND-USE") === "Y" && (
                                                <tr>
                                                    <th width="20%">{getDetailOption("BACKGROUND-TITLE")}</th>
                                                    <td>
                                                        {findFixItem("ABSTRACT_DETAIL")?.isUseEditor === "Y" ? (
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html: data?.content1,
                                                                }}
                                                            ></div>
                                                        ) : (
                                                            data?.content1
                                                        )}
                                                    </td>
                                                </tr>
                                            )}
                                            {getDetailOption("METHOD-USE") === "Y" && (
                                                <tr>
                                                    <th width="20%">{getDetailOption("METHOD-TITLE")}</th>
                                                    <td>
                                                        {findFixItem("ABSTRACT_DETAIL")?.isUseEditor === "Y" ? (
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html: data?.content2,
                                                                }}
                                                            ></div>
                                                        ) : (
                                                            data?.content2
                                                        )}
                                                    </td>
                                                </tr>
                                            )}

                                            {getDetailOption("RESULTS-USE") === "Y" && (
                                                <tr>
                                                    <th width="20%">{getDetailOption("RESULTS-TITLE")}</th>
                                                    <td>
                                                        {findFixItem("ABSTRACT_DETAIL")?.isUseEditor === "Y" ? (
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html: data?.content3,
                                                                }}
                                                            ></div>
                                                        ) : (
                                                            data?.content3
                                                        )}
                                                    </td>
                                                </tr>
                                            )}
                                            {getDetailOption("CONCLUSIONS-USE") === "Y" && (
                                                <tr>
                                                    <th width="20%">{getDetailOption("CONCLUSIONS-TITLE")}</th>
                                                    <td>
                                                        {findFixItem("ABSTRACT_DETAIL")?.isUseEditor === "Y" ? (
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html: data?.content4,
                                                                }}
                                                            ></div>
                                                        ) : (
                                                            data?.content4
                                                        )}
                                                    </td>
                                                </tr>
                                            )}
                                        </table>
                                    </td>
                                </tr>
                            )}
                            {findFixItem("FILE") && (
                                <tr>
                                    <th>{findFixItem("FILE")?.title}</th>
                                    <td>
                                        {data?.files?.map((file, index) => (
                                            <div>
                                                Attachment {index + 1} :{" "}
                                                <a href={file.signedUrl} target="_blank">
                                                    {file.fileName}
                                                </a>
                                            </div>
                                        ))}
                                    </td>
                                </tr>
                            )}
                            {findFixItem("KEYWORD") && (
                                <tr>
                                    <th>{findFixItem("KEYWORD")?.title}</th>
                                    <td>{data?.keyword?.join(",")}</td>
                                </tr>
                            )}
                            {cfg?.isUseTopic === "Y" && (
                                <>
                                    {cfg?.isUseTopicSecond === "Y" ? (
                                        <>
                                            <tr>
                                                <th>Topic 1st Choice </th>
                                                <td>{data?.topicFirst}</td>
                                            </tr>
                                            <tr>
                                                <th>Topic 2nd Choice </th>
                                                <td>{data?.topicSecond}</td>
                                            </tr>
                                        </>
                                    ) : (
                                        <tr>
                                            <th>Topic Choice </th>
                                            <td>{data?.topicFirst}</td>
                                        </tr>
                                    )}
                                </>
                            )}
                            {findFixItem("AUTHOR") && (
                                <>
                                    <tr>
                                        <th>Affiliation</th>
                                        <td>{getAff()}</td>
                                    </tr>
                                    <tr>
                                        <th>Authors</th>
                                        <td>{getAuthor()}</td>
                                    </tr>
                                </>
                            )}
                        </table>
                        {findFixItem("CONFIRM") && (
                            <center>
                                <label>
                                    <input type="checkbox" name="approved_chk" readOnly={true} checked={data?.agreement === "Y"} /> &nbsp;{findFixItem("CONFIRM")?.title}
                                </label>
                            </center>
                        )}

                        <table className="tbl_abs mt40">
                            <tr>
                                <th width="20%">Signature (Name)</th>
                                <td>
                                    <input type="text" name="signuture" value={data?.signuture} readOnly={true} />
                                </td>
                            </tr>
                            <tr>
                                <th>Date</th>
                                <td>
                                    <input type="text" name="signutureDate" value={data?.signutureDate} readOnly={true} />
                                </td>
                            </tr>
                        </table>


                        {findFixItem("PREVIEW") && (
                            <p className="abstract_preview">
                                <h2>{findFixItem("PREVIEW")?.title}</h2>
                                <p dangerouslySetInnerHTML={{ __html: findFixItem("PREVIEW")?.memo }}></p>
                            </p>
                        )}

                        <div className="btnArea1">
                            <button className="mgr5 btn1  btnGray1_go " onClick={() => navigate(`/abstract/modify/step1/${idx}`)}>
                                Back
                            </button>
                            <button type="button" className=" btn1  btnBlue1_go" onClick={onSave}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
